import { mapGetters } from "vuex";

export const toonDescription = {
  computed: {
    ...mapGetters(["initiatief"])
  },
  methods: {
    // toonRichting laat de beschrijving zien van het type onderwijs, bv. openbaar onderwijs
    toonRichting(richting) {
      var x = "";
      if (this.initiatief.richtingen !== undefined) {
        for (var i = 0; i < this.initiatief.richtingen.length; i++) {
          if (richting === this.initiatief.richtingen[i].id) {
            x = this.initiatief.richtingen[i].description;
          }
        }
      }
      return x;
    },
    // toonSoort laat de beschrijving zien van de sector, bv. primair onderwijs
    toonSoort(sector) {
      var x = "";
      if (this.initiatief.sectoren !== undefined) {
        for (var i = 0; i < this.initiatief.sectoren.length; i++) {
          if (sector === this.initiatief.sectoren[i].id) {
            x = this.initiatief.sectoren[i].description;
          }
        }
      }
      return x;
    },
    // toonProfiel laat de beschrijving zien van de profielen, bv. economie
    toonProfiel(profiel) {
      var x = "";
      if (this.initiatief.profielen !== undefined) {
        for (var i = 0; i < this.initiatief.profielen.length; i++) {
          if (profiel === this.initiatief.profielen[i].id) {
            x = this.initiatief.profielen[i].description;
          }
        }
      }
      return x;
    },
    // toonOpleiding laat de beschrijving zien van het soort onderwijs, bv. havo
    toonOpleiding(opleiding) {
      var x = "";
      if (this.initiatief.vo_typen !== undefined) {
        for (var i = 0; i < this.initiatief.vo_typen.length; i++) {
          if (opleiding === this.initiatief.vo_typen[i].id) {
            x = this.initiatief.vo_typen[i].description;
          }
        }
      }
      return x;
    },
    // toonProfiel laat de beschrijving zien van de uitbreidingsoort VO_items, bv. SPLITSING
    toonUitbreidingssoortVo(vo_uitbreidingssoort) {
      var x = "";
      if (this.initiatief.uitbreidingsoortVo_items !== undefined) {
        for (var i = 0; i < this.initiatief.uitbreidingsoortVo_items.length; i++) {
          if (vo_uitbreidingssoort === this.initiatief.uitbreidingsoortVo_items[i].id) {
            x = this.initiatief.uitbreidingsoortVo_items[i].description;
          }
        }
      }
      return x;
    },
    // toonProfiel laat de beschrijving zien van de uitbreidingsoort PO_items, bv. SPLITSING
    toonUitbreidingssoortPo(po_uitbreidingssoort) {
      var x = "";
      if (this.initiatief.uitbreidingsoortPo_items !== undefined) {
        for (var i = 0; i < this.initiatief.uitbreidingsoortPo_items.length; i++) {
          if (po_uitbreidingssoort === this.initiatief.uitbreidingsoortPo_items[i].id) {
            x = this.initiatief.uitbreidingsoortPo_items[i].description;
          }
        }
      }
      return x;
    }
  }
};
